export enum AppointmentRoutes {
  INDEX = '/appointments',
  CREATE_BY_USER_ID = '/appointments/create/:userId',
  CREATE = '/appointments/create',
  UPDATE = '/appointments/:id/update/:userId',
  DETAILS = '/appointments/:id/details',
  CALENDAR = '/appointments/calendar',
  ADD_PRODUCT = '/appointments/:id/add-product',
  PRODUCT_DETAILS = '/appointments/:id/product/details',
  BY_TYPE = '/appointments/:id/:type',
}
